import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const SearchInfoAdvanced = ({ queryKey, clang, dictionary }) => {
    const getKey = (key, name) => {
        const newName = name.toLowerCase().replace(/_/g, '-');

        if (dictionary[newName]) {
            const dictClang = dictionary[newName].filter(dict => dict.lang === clang)[0];
            const dictEntries = dictClang ? dictClang.entries : false;
            const entry = dictEntries ? dictEntries.filter(entry => entry.id === key)[0] : false;

            if (entry) {
                return entry.label;
            }
        }

        if (name.includes('YEAR') || name.includes('DATE')) {
            return  (key.split('-')[0] ? lang[clang].advanced_search.dates_from + ": " + key.split('-')[0] : "") +
                    (key.split('-')[1] ? " " + lang[clang].advanced_search.dates_to + ": " + key.split('-')[1] : "");
        }

        return key;
    };

    const getOptionValues = (str, name) => {
        if (str) {
            const options = str.split('%3B').map(option => {
                                return {
                                    key: decodeURIComponent(getKey(option.split('%2C')[0], name)),
                                    separator: option.split('%2C')[1]
                                }
                            });

            return options;
        }

        return;
    };

    const getValues = (str, name) => {
        if (str) {
            const options = str.split('%3B').map(option => {
                                return {
                                    relation: option.split('%')[0],
                                    values: option.includes('%3A') ?
                                                getOptionValues(option.split('%3A')[1], name)
                                                : [{separator: option.split('%2C')[1]}],
                                }
                            });

            return options;
        }

        return;
    };

    const separatedAttr = queryKey.split('%26').map(attr => {
                              return {
                                  name: attr.split('%3D')[0],
                                  values: getValues(attr.split('%3D')[1], attr.split('%3D')[0])
                              }
                          });

    return (
        <div className="search-info">
            <div className="search-info__content">
                <div className="search-info__key">
                    <span className="search-info__key-label">{lang[clang].search.info}:</span>
                    <ul className="search-info__list">
                        {separatedAttr.map((attr, attrIndex) =>
                            <li key={attrIndex} className="search-info__list-item">
                                <div className="search-info__list-attr">{lang[clang].advanced_search.search_field_options[attr.name]}:</div>
                                <div className="search-info__list-attr__val">
                                    {attr.values && attr.values.map((val, valIndex) =>
                                        <div key={valIndex} className="search-info__list-key">
                                            <span>[</span>
                                            <div className="search-info__list-relation">{lang[clang].advanced_search.search_field_options[val.relation]}</div>
                                            {val.values && val.values.length > 0 &&
                                                <div className="search-info__list-key__inner">
                                                    {val.values && val.values.map((nestedVal, nestedValIndex) =>
                                                        <div key={nestedValIndex} className="search-info__list-key__inner__val">
                                                            {nestedVal.key &&
                                                                <div className="search-info__list-key__inner__val-key">
                                                                    {nestedVal.key}
                                                                </div>}
                                                            <span>]</span>
                                                            {nestedVal.separator &&
                                                                <div className="search-info__list-key__inner__val-separator">
                                                                    {lang[clang].advanced_search.search_field_options[nestedVal.separator]}
                                                                </div>}
                                                        </div>)}
                                                </div>}
                                            {(!val.values || val.values.length < 1) && <span>]</span>}
                                        </div>)}
                                </div>
                                {separatedAttr.length - 1 > attrIndex && <div className="search-info__list-key__inner__val-separator-general">,</div>}
                            </li>)}
                    </ul>
                </div>
            </div>
        </div>
    );
};

SearchInfoAdvanced.propTypes = {
    clang: propTypes.string.isRequired,
    dictionary: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    dictionary: state.language.dictionary,
});

export default connect(mapStateToProps)(SearchInfoAdvanced);



// WEBPACK FOOTER //
// ./src/components/search/SearchInfoAdvanced.js